import { CircleAlert, Clock, ReceiptText, XCircle } from 'lucide-react'

import { Button } from '@krp/ui-kit'

import type { LatePaymentVm } from '../port/types'

/**
 * Запоздавший слип после отмены оплаты: служба нашла в кабинете покупку на ту же сумму, покупатель, возможно, всё-таки заплатил.
 * Текст службы - дословно, с иконкой и словом «Важно» (не только цвет). Два выхода: «Оплаты не было» и «Оплата прошла — пробить чек».
 * Пока команда в пути, кнопки заблокированы и видно «Отправляем…»; недоступное - с иконкой часов и словами, почему.
 */
export function LatePaymentChoice({ latePayment, onResolve }: { latePayment: LatePaymentVm; onResolve: (paid: boolean) => void }) {
  const disabled = !latePayment.canAct
  return (
    <section className="rmk-late-payment" aria-label="Слип после отмены оплаты" data-tone="danger">
      <p className="rmk-checkout__notice" role="alert">
        <CircleAlert size={15} aria-hidden="true" /> {latePayment.text}
      </p>
      <div className="rmk-progress__actions">
        <Button icon={<XCircle size={16} aria-hidden="true" />} disabled={disabled} onClick={() => onResolve(false)}>
          Оплаты не было
        </Button>
        <Button variant="primary" icon={<ReceiptText size={16} aria-hidden="true" />} disabled={disabled} onClick={() => onResolve(true)}>
          Оплата прошла — пробить чек
        </Button>
      </div>
      {latePayment.sending && (
        <p className="sale-text" role="status">
          <Clock size={14} aria-hidden="true" /> Отправляем…
        </p>
      )}
      {latePayment.blockedText !== null && (
        <p className="sale-text" role="status">
          <Clock size={14} aria-hidden="true" /> {latePayment.blockedText}
        </p>
      )}
    </section>
  )
}
